export default __webpack_public_path__ + "static/media/doctor3.c55ce4a2.png";